import { User, BookOpen, Briefcase, Newspaper } from "lucide-vue-next";

export const tabs = [
  { value: "about", label: "About", icon: User },
  { value: "resume", label: "Resume", icon: BookOpen },
  { value: "portfolio", label: "Portfolio", icon: Briefcase },
  { value: "blog", label: "Blog", icon: Newspaper },
];
